import React from "react";
import { Divisor } from "../../bci/styles";

export const DisclaimerAraucaria: React.FC = () => {
    return (
        <div>
            <div className="text-center">
                <h5>CONSULTA PRÉVIA PARA VIABILIDADE DE CONSTRUÇÃO</h5>
                <p>
                    A Consulta para Construção é um documento emitido pela
                    Prefeitura do Município de Araucária onde constam as
                    informações sobre os usos e parâmetros construtivos para
                    determinado lote. As informações aqui contidas são de
                    caráter preliminar e não substituem a legislação vigente e
                    não se encerram em si mesmas, sendo obrigatório o
                    cumprimento de toda a legislação pertinente, citada ou não.
                    (Lei Complementar 26/2020, Arts 24 e 25)
                </p>
            </div>
            <Divisor />
            <div>
                <p>
                    OS ÓRGÃOS COMPETENTES DEVERÃO SER CONSULTADOS EM RELAÇÃO ÀS
                    DIRETRIZES DO SISTEMA VIÁRIO, ÁREAS DE PRESERVAÇÃO
                    PERMANENTE E FAIXAS DE SERVIDÃO
                </p>
            </div>
        </div>
    );
};
